export function onCheckDisabledConditions(...args: boolean[]) {
    return args.includes(false)
}
